import { axiosPrivate } from 'shared/api';
import { IExpertise } from 'features/cost-analysis/team/expertises/types';
import { BaseService } from 'shared/services/BaseService';

class ExpertiseService extends BaseService<IExpertise> {
  constructor() {
    super('staff-management/expertises');
  }
  canDelete = true;

  getRoleNames = async () => {
    return (await axiosPrivate.get('staff-management/role-names/')).data;
  };
}

export const expertiseService = new ExpertiseService();
